/**
 * 组件使用场景：出价记录，修改记录，流拍记录, 玩法规则, 关注记录
 * API使用 ->
 * API:import { showRecord } from '@/shared/utils';
 * showRecord({
 *     id:'' //主键id =>required
 *     type:'' // 查看记录类型 'edit'：修改 | 'auction'：流拍 | 'offer' ：出价 => required
 *     callback:()=>void // 打开记录之后的回调
 * })
 * */
import React, { Component } from 'react';
import { ConfigProvider, Modal, Table, Button, Tabs } from 'antd';
import ReactDOM from 'react-dom';
import zh_CN from 'antd/es/locale/zh_CN';
import { connect, Provider } from '@souche-f2e/muji';
import store, { dispatch, getState } from '@@/store';
import { dealListValueShow } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
const mapStateToProps = (rootState) => ({
    record: rootState.recordDetail,
});
class RecordDetail extends Component {
    constructor(props) {
        super(props);
        // 渲染拍卖详情
        this._renderAuctionDetail = (text) => {
            // 记录JSON
            const record = JSON.parse(text);
            switch (record.auctionMode) {
                case 'XCP':
                    let tempCustomPriceButton = [];
                    if (typeof record.customPriceButton === 'string') {
                        const noQuotesStr = record.customPriceButton.replace(/'/g, '');
                        tempCustomPriceButton = noQuotesStr.substring(1, noQuotesStr.length - 1).split(',');
                    }
                    else {
                        tempCustomPriceButton = record.customPriceButton;
                    }
                    return (<div>
            <div>加价按钮: {tempCustomPriceButton.join('、').toString().replace('-1', '自定义')}</div>
            <div>倒计时时间: {record.countdownDuration}s</div>
          </div>);
                case 'APC':
                    return (<div>
            <div>出价次数: {record.bidTimes}次</div>
            <div>流拍时长:{record.auctionFailedDuration}小时</div>
            <div>提醒: {this.handleTipShow([
                        { label: '最终出价排名', key: record.bidRankRemind },
                        { label: '成交价通知', key: record.finalPriceRemind },
                        { label: '最高价提醒', key: record.highestPriceRemind },
                    ])}
            </div>
            <div>成交规则:
              最高出价者以次高价成交{record.secondPriceDeal ? '开启' : '关闭'}、
              竞拍中场次的下架功能{record.auctionTakeOff ? '开启' : '关闭'}、
              不超保留价自动流拍{record.automaticAuctionFailed ? '开启' : '关闭'}
            </div>
            <div>竞拍规则:
              竞拍冻结保证金{record.frozenDepositTag ? '开启' : '关闭'}
              {!record.frozenDepositTag && `、竞拍允许取消报价${record.allowCancelBid ? '开启' : '关闭'}`}
            </div>
          </div>);
                case 'CDP':
                    return (<div>
            <div>单车拍卖时长: {record.singleCarAuctionDuration}分钟</div>
          </div>);
                case 'SUPER_XCP':
                    return (<div>
            <div>投标时长：{record.carAuctionDuration}小时</div>
            <div>超级拍流拍时长：{record.auctionFailedDuration}小时</div>
            <div>显示标签: {this.handleTipShow([
                        {
                            label: '投标最高价标签',
                            key: record.tenderHighestDisplay,
                        },
                        {
                            label: '竞拍当前最高价标签',
                            key: record.auctionHighestDisplay,
                        },
                        {
                            label: '高于低于投标价标签',
                            key: record.compareWithTenderDisplay,
                        },
                    ])}
            </div>
          </div>);
                case 'SUPER_CDP':
                    return (<div>
            <div>投标时长：{record.carAuctionDuration}小时</div>
            <div>超级拍流拍时长：{record.auctionFailedDuration}小时</div>
            <div>单车拍卖时长：{record.singleCarAuctionDuration}分钟</div>
            <div>显示标签: {this.handleTipShow([
                        {
                            label: '投标最高价标签',
                            key: record.tenderHighestDisplay,
                        },
                        {
                            label: '高于低于投标价标签',
                            key: record.compareWithTenderDisplay,
                        },
                    ])}
            </div>
          </div>);
                default:
                    return '--';
            }
        };
        // 渲染用户名
        this._renderUserName = (text) => {
            return (text !== fontEndConfig.noValueReplace ? <span>{text}</span> :
                (<div>
            <span>--</span>
            <span style={{
                    color: '#666',
                    background: '#f2f3f5',
                    borderRadius: '2px',
                    display: 'inline-block',
                    padding: '0 4px',
                    height: '18px',
                    lineHeight: '18px',
                    marginLeft: '10px',
                }}>
              未登录用户
            </span>
          </div>));
        };
        this._renderPhone = (text) => {
            return text.replace(/(^\d{3}|\d{4}\B)/g, '$1 ');
        };
        this.state = {
            offer: [
                {
                    title: '买家',
                    dataIndex: 'buyerPhone',
                    width: 250,
                    render: (text, record) => {
                        const { realName = '' } = record;
                        return (<div style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                        }}>
                {realName && <span>{realName}</span>}
                <span>{text}</span>
              </div>);
                    },
                },
                {
                    title: '出价时间',
                    dataIndex: 'createTime',
                    width: 250,
                },
                {
                    title: '出价金额（元）',
                    dataIndex: 'carPriceY',
                    width: 180,
                },
                {
                    title: '合手价（元）',
                    dataIndex: 'offerPriceY',
                    width: 180,
                },
                {
                    title: '类型',
                    dataIndex: 'lineTypeName',
                    width: 100,
                },
                {
                    title: '平台',
                    dataIndex: 'bidPlatformId',
                    width: 100,
                    render: (bidPlatformId) => {
                        let bidPlatformName = bidPlatformId;
                        switch (bidPlatformId) {
                            case 10:
                                bidPlatformName = '车易拍';
                                break;
                            default:
                                bidPlatformName = '自有平台';
                                break;
                        }
                        return <span>{bidPlatformName}</span>;
                    },
                },
            ],
            auction: [
                {
                    title: '经销商名称',
                    dataIndex: 'sellerName',
                    width: 250,
                },
                {
                    title: '流拍时间',
                    dataIndex: 'createTime',
                    width: 300,
                },
                {
                    title: '最高价(元)',
                    dataIndex: 'priorityOfferYuan',
                    width: 150,
                    render: (text) => {
                        return text !== fontEndConfig.noValueReplace ? (<span>{text}</span>) : (<span>0</span>);
                    },
                },
                {
                    title: '流拍原因',
                    dataIndex: 'remark',
                    width: 300,
                },
            ],
            brokerage: [
                {
                    title: '修改人',
                    dataIndex: 'editedBy',
                    width: 200,
                },
                {
                    title: '修改时间',
                    dataIndex: 'createTime',
                    width: 200,
                },
                {
                    title: '修改前',
                    dataIndex: 'oldValue',
                    width: 300,
                    render: (text) => {
                        return this._renderTextBr(text);
                    },
                },
                {
                    title: '修改后',
                    dataIndex: 'newValue',
                    width: 300,
                    render: (text) => {
                        return this._renderTextBr(text);
                    },
                },
            ],
            commission: [
                {
                    title: '修改人',
                    dataIndex: 'editedBy',
                    width: 200,
                },
                {
                    title: '修改时间',
                    dataIndex: 'createTime',
                    width: 200,
                },
                {
                    title: '修改前',
                    dataIndex: 'oldValue',
                    width: 300,
                    render: (text) => {
                        return this._renderTextBr(text);
                    },
                },
                {
                    title: '修改后',
                    dataIndex: 'newValue',
                    width: 300,
                    render: (text) => {
                        return this._renderTextBr(text);
                    },
                },
            ],
            playRules: [
                {
                    title: '修改人',
                    dataIndex: 'editedBy',
                    width: 200,
                },
                {
                    title: '修改时间',
                    dataIndex: 'createTime',
                    width: 200,
                },
                {
                    title: '修改前',
                    dataIndex: 'oldValue',
                    width: 300,
                    align: 'left',
                    render: (text) => {
                        return this._renderAuctionDetail(text);
                    },
                },
                {
                    title: '修改后',
                    dataIndex: 'newValue',
                    width: 300,
                    align: 'left',
                    render: (text) => {
                        return this._renderAuctionDetail(text);
                    },
                },
            ],
            focus: [
                {
                    title: '买家姓名',
                    dataIndex: 'buyerName',
                    width: 200,
                    render: (text) => {
                        return this._renderUserName(text);
                    },
                },
                {
                    title: '手机号',
                    dataIndex: 'buyerPhone',
                    width: 200,
                    render: (text) => {
                        return this._renderPhone(text);
                    },
                },
                {
                    title: '是否可参拍',
                    dataIndex: 'isAuction',
                    width: 300,
                    render: (text) => {
                        return text === 1 ? '是' : '否';
                    },
                },
                {
                    title: '所属机构',
                    dataIndex: 'platformType',
                    width: 300,
                    render: (text) => {
                        return text === 1 ? '本机构' : '车易拍';
                    },
                },
            ],
            browse: [
                {
                    title: '买家姓名',
                    dataIndex: 'buyerName',
                    width: 200,
                    render: (text) => {
                        return this._renderUserName(text);
                    },
                },
                {
                    title: '手机号',
                    dataIndex: 'buyerPhone',
                    width: 200,
                    render: (text) => {
                        return this._renderPhone(text);
                    },
                },
                {
                    title: '查看次数',
                    dataIndex: 'times',
                    width: 200,
                },
                {
                    title: '所属机构',
                    dataIndex: 'platformType',
                    width: 200,
                    render: (text) => {
                        return text === 1 ? '本机构' : '车易拍';
                    },
                },
                {
                    title: '最近查看时间',
                    dataIndex: 'createTime',
                    width: 300,
                },
            ],
        };
        this.tabChange = this.tabChange.bind(this);
    }
    cancel() {
        dispatch.recordDetail.hide();
    }
    afterClose() {
        dispatch.recordDetail.resetState();
    }
    tableUpdate(index) {
        dispatch.recordDetail.updateData({ index });
    }
    /**
     * key1 lable 1
     * key2 lable 2
     * ...argv
     */
    handleTipShow(arr) {
        const tipShowArr = [];
        arr.map((item, index) => {
            item.key && tipShowArr.push(item.label);
        });
        return tipShowArr.length > 0 ? tipShowArr.join('、') : '--';
    }
    _renderTextBr(text) {
        return <div dangerouslySetInnerHTML={{ __html: text.replace(/[,，]/g, '<br>') }}/>;
    }
    tabChange(activeKey) {
        dispatch.recordDetail.changeTab(activeKey);
    }
    _renderCancellationSign() {
        const { type, tableData, offerAuctionMode, activeTab } = this.props.record;
        const showSign = type === 'offer' && offerAuctionMode === 1011 && activeTab === '2';
        if (!showSign) {
            return null;
        }
        const dataCancellationList = tableData.filter((item) => item.status === 2);
        return dataCancellationList.length > 0 ? (<div style={{
            position: 'absolute',
            zIndex: 1,
            right: '25px',
            top: '135px',
        }}>
        <img src="https://assets.souche.com/assets/sccimg/auctionSass/cancellate.png" alt="作废"/>
      </div>) : null;
    }
    render() {
        const { type, visible, title, tableData, tableRowkey, pageIndex, pageSize, total, activeTab, loading, offerAuctionMode, pageIndexAuction, totalAuction } = this.props.record;
        const tableColumn = this.state[type] || [];
        return (<ConfigProvider locale={zh_CN}>
        <Modal visible={visible} title={title} footer={<Button type={'primary'} onClick={this.cancel}>确定</Button>} afterClose={this.afterClose} onCancel={this.cancel} width={1200}>
          {(offerAuctionMode === 1011 || offerAuctionMode === 1021) && ( // 超级拍-现场拍 & 超级拍-车道拍
        <Tabs activeKey={activeTab} onChange={this.tabChange}>
                <Tabs.TabPane key={'1'} tab={'投标出价'}/>
                <Tabs.TabPane key={'2'} tab={'竞拍出价'}/>
              </Tabs>)}
          {this._renderCancellationSign()}
          <Table className={'draw_table_all_border'} loading={loading} scroll={{ y: 400 }} bordered columns={tableColumn} dataSource={dealListValueShow({
            gistData: tableColumn,
            data: tableData,
        })} rowKey={tableRowkey} pagination={type === 'auction' ? false : {
            current: activeTab === '2' ? pageIndexAuction : pageIndex,
            pageSize,
            showQuickJumper: true,
            total: activeTab === '2' ? totalAuction : total,
            onChange: this.tableUpdate,
        }}/>
        </Modal>
      </ConfigProvider>);
    }
}
RecordDetail.defaultProps = {};
const RecordDetailComponent = connect(mapStateToProps, null, null, { forwardRef: true })(RecordDetail);
export default RecordDetailComponent;
/**
 * API
 * */
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    div.className = 'record_detail_modal';
    document.body.appendChild(div);
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(RecordDetailComponent, {
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showRecord({ id, type }) {
    if (!document.querySelector('.record_detail_modal')) {
        createAbortiveAuction();
    }
    dispatch.recordDetail.show({ id, type });
}
export const updateRecordData = ({ index, size }) => {
    const { type, pageIndex } = getState().recordDetail;
    type !== '' && dispatch.recordDetail.updateData({ index: pageIndex || index, size });
};
export const getRecordDataCurrentIndex = () => {
    const { pageIndex, pageIndexAuction, activeTab, type } = getState().recordDetail;
    return type === 'offer' ?
        activeTab === '1' ? pageIndex : pageIndexAuction
        : pageIndex;
};
